/*
 * @Author: zhaoyu zhaoy@normstar.com
 * @Date: 2024-07-18 15:30:49
 * @LastEditors: zhaoyu zhaoy@normstar.com
 * @LastEditTime: 2024-08-26 10:23:33
 * @FilePath: \ns-web-evaluation\pc\src\utils\env.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export function getAppEnvConfig() {
  const {
    VITE_APP_TITLE: title,
    VITE_SHORT_NAME: shortName,
    VITE_NODE_ENV,
    VITE_APP_PROJECT,
    VITE_APP_LANGUAGE,
    VITE_APP_FILE_Path
  } = import.meta.env
  return {
    isPro: VITE_NODE_ENV === 'production',
    isDev: VITE_NODE_ENV === 'development',
    isEhome: window.navigator.userAgent.toLowerCase()?.includes('ehomeapp'),
    isEhomePro: VITE_APP_PROJECT === 'epro',
    isPlatform: VITE_APP_PROJECT === 'platform',
    isNhxm: VITE_APP_PROJECT === 'nhxm',
    isZhxm: VITE_APP_PROJECT === 'zhxm',
    filePath: VITE_APP_FILE_Path,
    appProject: VITE_APP_PROJECT,
    // 是否开启南航统一认证
    // oauthFlag: true,
    oauthFlag: [
      '172.21.128.54',
      '172.21.128.55',
      'patest.csair.com',
      '10.84.91.161',
      '10.84.91.162',
      '10.84.91.163',
      'ta.csair.com',
      '10.84.92.39'
    ].includes(location.hostname),
    isLanguage: VITE_APP_LANGUAGE === 'true',
    shortName,
    title
  }
}
//获取当前模式
export function getEnv(): string {
  return import.meta.env.MODE
}

//是否开发环境
export function isDev(): boolean {
  return getAppEnvConfig().isDev
}

//是否生产环境
export function isPro(): boolean {
  return getAppEnvConfig().isPro
}
